export const defaultStyles = {
  sizing: {
    width: "100%",
    height: "auto",
    minWidth: "320px",
    minHeight: "auto",
    maxWidth: "none",
    maxHeight: "none",
  },
  padding: {
    paddingTop: "0",
    paddingRight: "0",
    paddingBottom: "0",
    paddingLeft: "0",
  },
  margin: {
    marginTop: "0",
    marginRight: "0",
    marginBottom: "0",
    marginLeft: "0",
  },
  borderRadius: {
    border_left_top_radius: 0,
    border_left_bottom_radius: 0,
    border_right_top_radius: 0,
    border_right_bottom_radius: 0,
  },
  backgroundColor: "#FFFFFF00",
} as const;
